import { render } from "./RegistrationFieldVendor.vue?vue&type=template&id=3483ce8c&scoped=true&ts=true"
import script from "./RegistrationFieldVendor.vue?vue&type=script&lang=ts"
export * from "./RegistrationFieldVendor.vue?vue&type=script&lang=ts"

import "./RegistrationFieldVendor.vue?vue&type=style&index=0&id=3483ce8c&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3483ce8c"]])

export default __exports__